var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.13 11.86a.2.2 0 11-.27.27.2.2 0 01.27-.27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17H4a2 2 0 01-2-2V9a2 2 0 012-2h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13 11.86a.2.2 0 11-.27.27.2.2 0 01.27-.27"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 6.5,
    x: 14,
    y: 10.5,
    rx: 1.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.53 10.5V8.47C15.53 7.1 16.63 6 18 6v0a2.47 2.47 0 012.47 2.47v2.05"
  }))));
}
export default SvgPassword;